import { Logo } from "./Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[color:var(--ns-line)] py-12">
    <div className="mx-auto flex max-w-7xl flex-col items-center gap-8 px-4 sm:px-8 lg:flex-row lg:justify-between lg:px-12">
      <a href="#top" data-testid="footer-logo-link" className="flex items-center gap-3">
        <Logo size={30} testId="footer-logo" />
        <span className="leading-none">
          <span className="block font-serif text-base text-[color:var(--ns-ink)]">Hunt Shield</span>
          <span className="block text-[9px] font-semibold uppercase tracking-[0.28em] text-[color:var(--ns-gold)]">
            Insurance Group
          </span>
        </span>
      </a>
      <p className="max-w-md text-center text-xs leading-relaxed text-[color:var(--ns-muted)] lg:text-left">
        Independent insurance guidance across Home &amp; Auto, Life &amp; Health, and
        Medicaid. Licensed in Georgia.
      </p>
      <div className="flex flex-col items-center gap-2 text-xs text-[color:var(--ns-muted)] lg:items-end">
        <p>© 2026 Hunt Shield Insurance Group · Atlanta, GA</p>
        <a
          href="/admin/login"
          data-testid="footer-admin-link"
          className="font-mono uppercase tracking-[0.2em] transition-colors hover:text-[color:var(--ns-gold)]"
        >
          Agent Portal
        </a>
      </div>
    </div>
  </footer>
);
